module.exports = __webpack_public_path__ + "img/default@2x.8d7f3446.png";